import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface selfParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface self { 

    receipt:receipt;
    receiptDetail:receiptDetail[];
    receiptBillDetail:receiptBillDetail[];
    
    parameters?: selfParameter[];
    links?: any;
}

export interface receipt { 

    ReceiptAmount:number;
    BillId:number;
    RegId:string;
    DoneFrom:string;
    OpBillNumber:string;
    createdBy:string;
    tenantId: string;
    branchId: string;

    parameters?: selfParameter[];
    links?: any;
}

export interface receiptDetail { 

    paymentMode:string;
    cash:number;
    creditCard:number;
    cheque:number;
    upiPayment:number;
    neft:number;
    transactionNo: string;
    tenantId: string;
    branchId: string;

    parameters?: selfParameter[];
    links?: any;
}

export interface receiptBillDetail { 

    patType:string;
    billId?:number;
    IpBillId?:number;
    amount:number;
    amtSetteled:number;
    createdBy:string;
    tenantId: string;
    branchId: string;

    parameters?: selfParameter[];
    links?: any;
}


export abstract class selfData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<self[]>;
    abstract create(url: string, data: self): Observable<self[]>;
    abstract getData(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: self): Observable<self>;
}
